export const PLAN_LIMITS = {
  free: {
    maxFileSize: 60,      // MB - 개별 파일 상한
    maxTotalStorage: 60,  // MB - 총 용량 상한
  },
} as const;

export type PlanType = keyof typeof PLAN_LIMITS;
export const CURRENT_PLAN: PlanType = 'free';
